require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/resizable');
require('jquery-ui/themes/base/resizable.css');

require('./jquery-helpers');

// necessary for css ordering (so other css can overwrite it instead of the other way around):
require('jqwidgets/styles/jqx.base.css');
require('jqwidgets/styles/jqx.bootstrap.css');
require('smart-webcomponents/source/styles/smart.default.css');
require('@fortawesome/fontawesome-free/css/all.min.css');
require('@fortawesome/fontawesome-free/css/v4-shims.min.css');
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap-icons/font/bootstrap-icons.css');

require('./favicon.png');
require('./admin.css');

const bootstrap = require('bootstrap/dist/js/bootstrap.bundle.min.js');
const GraphileonClient = require('client/src/client').default;
const panelContainer = require('./containers/container-content');
const modalContainer = require('./containers/container-modal').default;
const Log = require('core/src/log');

const log = Log.instance('client');

const client = new GraphileonClient({
	router: {
		enabled: true,
		rootToDefaultDashboard: true,
		baseRoute: '/dashboard'
	}
});
client.viewmanager.register(require('./user-view/user-view-renderer'));
client.factory.register(require('./user-view/user-view'));

$(document).ready(function() {
	const viewmanager = client.viewmanager;
	viewmanager.promptArea = 'content';
	viewmanager.defaultArea = 'content';
	viewmanager.setContainerPrototype('content', panelContainer);
	viewmanager.setContainerPrototype('modal', modalContainer);

	client.on(GraphileonClient.Event.ERROR_CONFIGURATION, function() {
		window.location = 'settings/index.html';
	});
	client.on(GraphileonClient.Event.SESSION_EXPIRED, () => {
		client.session.logOffUser();
		location.reload();
	});
	
	client.on(GraphileonClient.Event.AUTOLOGIN_FAILED, () => {
		client.executeLoginView(client.appInfo.loginView);
	});
	client.on(GraphileonClient.Event.LOGIN_REQUIRED, () => {
		client.closeDashboard();
		client.executeLoginView(client.appInfo.loginView);
	});

	client.on(GraphileonClient.Event.ROUTE_UNRESOLVED, () => {
		log.log('No route matched. Loading default dashboard.');
		client.loadDefaultDashboard();
	});
	client.on(GraphileonClient.Event.DASHBOARD_LOADED, () => {
		if(!client.session.isLoggedIn()) {
			return;
		}

		const user = client.session.getUser();
		let func = client.factory.createFunctionInstance("UserView");
		func.execute({
			area: 'sidebar-left',
			container: {
				id: 'user-view',
				index: -99,
				title: user.properties.name,
				headerVisible: false
			},
			user: user,
			dashboards: client.appInfo.dashboards,
			shortcuts: client.appInfo.shortcuts
		});
	});
	client.on(GraphileonClient.Event.LOADING_STARTED, () => {
		$('.spinner').show();
	});
	client.on(GraphileonClient.Event.LOADING_FINISHED, () => {
		$('.spinner').hide();
	})

	client.on(GraphileonClient.Event.LOGOUT, () => {location.reload()});

	client.start();


	const hideAllTooltips = (excludeElement = null) => {
		$('[data-bs-initialized="true"]').each((indx, el) => {
			if (el !== excludeElement) {
				const tooltip = bootstrap.Tooltip.getInstance(el);
				if (tooltip) {
					tooltip.hide();
				}
			}
		});
	};

	const initTooltips = (root = document) => {
		const tooltipTriggerList = root.querySelectorAll('[data-bs-toggle="tooltip"]:not([data-bs-initialized])');
		tooltipTriggerList.forEach(el => {
			new bootstrap.Tooltip(el);
			el.setAttribute('data-bs-initialized', 'true');
		});
	};

	// init tooltips for initial content
	initTooltips(document);

	// Use MutationObserver to initialize tooltips on new content and hide them when modals appear
	const observer = new MutationObserver(mutations => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (node.nodeType === 1) { // Element node
					initTooltips(node);
				}
			}
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });

	// Add a listener to hide other tooltips when a new one is shown
	document.body.addEventListener('show.bs.tooltip', (e) => {
		hideAllTooltips(e.target);
	}, true);

	// Add a single delegated click listener to hide the tooltip when its trigger is clicked
	$(document.body).on('click', function (e) {
		setTimeout(() => {
			$('.bs-tooltip-auto').remove();
		}, 0);
	});
});
window.graphileonClient = client;
